import React from 'react';

const NonBreakableSpace = () => {
  return <div>&nbsp;</div>;
};

export default NonBreakableSpace;
